// @ts-nocheck

export const isMobile = () => {
  // 더 정확한 모바일 감지
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  const isMobileDevice =
    /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
      userAgent
    )
  const isSmallScreen = window.innerWidth <= 768

  return isMobileDevice || isSmallScreen
}

export const isWeb = () => {
  return !isMobile()
}

export const getDeviceType = () => {
  return isMobile() ? 'mobile' : 'web'
}

export const getYouTubeDeepLink = (videoId) => {
  // 모바일에서 YouTube 앱으로 연결하는 딥링크 (여러 형식 시도)
  return `https://www.youtube.com/watch?v=${videoId}`
}

export const getYouTubeWebUrl = (
  videoId,
  isShorts = false,
  playbackMode = 'manual'
) => {
  // 웹에서 YouTube iframe으로 사용할 URL
  const baseUrl = `https://www.youtube.com/embed/${videoId}`
  const params = new URLSearchParams({
    autoplay: '1', // 자동 재생
    mute: playbackMode === 'auto' ? '1' : '0', // 자동재생 모드면 음소거, 수동 모드면 소리 켜기
    controls: '1',
    showinfo: '0',
    rel: '0',
  })

  if (isShorts) {
    // Shorts용 특별 설정
    params.set('modestbranding', '1')
    params.set('fs', '0')
    params.set('iv_load_policy', '3')
  } else {
    // 일반 영상용 설정
    params.set('loop', '1')
    params.set('playlist', videoId)
  }

  return `${baseUrl}?${params.toString()}`
}

export const isYouTubeShorts = (url) => {
  // YouTube 쇼츠 URL 감지
  return url.includes('/shorts/') || url.includes('youtube.com/shorts/')
}

export const getVideoAspectRatio = (isShorts) => {
  // 쇼츠는 9:16, 일반 영상은 16:9
  return isShorts ? 'aspect-[9/16]' : 'aspect-video'
}

export const getVideoContainerClass = (isShorts) => {
  // 쇼츠와 일반 영상에 따른 컨테이너 클래스
  if (isShorts) {
    // 쇼츠: 중앙 정렬, 화면 전체 사용 (스크롤 방지)
    return 'w-full h-screen flex items-center justify-center overflow-hidden'
  }
  return 'w-full h-screen flex items-center justify-center'
}

export const getVideoSizeStyle = (isShorts) => {
  const screenWidth = window.innerWidth
  const screenHeight = window.innerHeight
  const screenRatio = screenWidth / screenHeight

  if (isShorts) {
    // 쇼츠: 9:16 비율 유지하면서 화면에 맞게
    const shortsRatio = 9 / 16
    let width, height

    if (screenRatio > shortsRatio) {
      // 화면이 더 넓음 - 높이 기준
      height = Math.min(screenHeight * 0.95, screenWidth / shortsRatio)
      width = height * shortsRatio
    } else {
      // 화면이 더 좁음 - 너비 기준
      width = Math.min(screenWidth * 0.9, screenHeight * shortsRatio)
      height = width / shortsRatio
    }

    return {
      width: `${width}px`,
      height: `${height}px`,
      maxWidth: '100%',
      maxHeight: '95vh',
    }
  } else {
    // 일반 영상: 16:9 비율 유지하면서 화면에 맞게
    const videoRatio = 16 / 9
    let width, height

    if (screenRatio > videoRatio) {
      // 화면이 더 넓음 - 높이 기준
      height = Math.min(screenHeight * 0.95, screenWidth / videoRatio)
      width = height * videoRatio
    } else {
      // 화면이 더 좁음 - 너비 기준
      width = Math.min(screenWidth * 0.95, screenHeight * videoRatio)
      height = width / videoRatio
    }

    return {
      width: `${width}px`,
      height: `${height}px`,
      maxWidth: '95vw',
      maxHeight: '95vh',
    }
  }
}

export const openYouTubeApp = (videoId, onSuccess, onFail) => {
  let appOpened = false

  // Visibility API로 앱 실행 감지
  const handleVisibilityChange = () => {
    if (document.hidden) {
      appOpened = true // 앱으로 이동됨
      if (onSuccess) onSuccess()
    }
  }

  document.addEventListener('visibilitychange', handleVisibilityChange)

  // 딥링크 시도
  const iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  iframe.src = `youtube://watch?v=${videoId}`
  document.body.appendChild(iframe)

  // 3초 후 확인
  setTimeout(() => {
    document.removeEventListener('visibilitychange', handleVisibilityChange)
    document.body.removeChild(iframe)

    if (!appOpened && onFail) {
      // 앱 실패 -> YouTube 모바일 웹으로 이동
      window.location.href = `https://m.youtube.com/watch?v=${videoId}`
    }
  }, 3000)
}
